import React, { Component } from 'react';
import { compose } from 'redux'
import { connect } from 'react-redux';
import './Home.css';
import withAuth from '../components/withAuth';
import PlannedInterventions from '../components/Home/PlannedInterventions';
import ContractsAndAffairs from '../components/Home/ContractsAndAffairs';
// import Indicators from '../components/Home/Indicators';
// import Documentations from '../components/Home/Documentations';
import { withStyles } from '@material-ui/core';
import MyComponentPark from '../components/Home/MyComponentPark';
import { authorizedAppsFetchData } from "../redux/authorizedApps/authorizedAppsActions";
import MyInvoices from '../components/Home/MyInvoices';
import Quotes from '../components/Home/Quotes';
import ContactUs from '../components/Home/ContactUs'
import { hideWidget, loadHiddenWidgets } from '../redux/home/homeWidgetActions';
import {
    MODULE_CONTACT_US, MODULE_EXTRANET_COMPONENTS_PARK, MODULE_EXTRANET_CONTRACTS_AND_AFFAIRS,
    // MODULE_EXTRANET_DOCUMENTATIONS, MODULE_EXTRANET_INDICATORS, 
    MODULE_EXTRANET_INTERVENTIONS, MODULE_EXTRANET_INVOICES, MODULE_EXTRANET_QUOTES
} from '../redux/authorizedApps/authorizedAppsConstants';
import { getUserToken } from '../redux/users/usersActions';

const styles = {
    cardActions: {
        padding: 1,
        width: "100%",
        display: "flex",
        flexDirection: "row-reverse",
        justifyContent: "space-between",
        marginTop: "auto",
        marginBottom: "3px",
        paddingLeft: "15px",
    },
    smallButton: {
        maxHeight: "24px",
    },
    iconStyle: {
        color: "#FE5815",
        fontSize: "36px",
    },
    faIconStyle: {
        color: "#FE5815",
        fontSize: "36px",
        height: "42px",
    },
    fatIcon: {
        color: "#FE5815",
        margin: "auto",
        fontSize: "80px",
    }
};

class ExtranetHome extends Component {

    async componentDidMount() {
        this.props.fetchData(this.props.activeUser);
        this.props.loadHiddenWidgets(this.props.activeUser.id);
    }

    closeCard(moduleCode, e) {
        e.stopPropagation();
        this.props.hideWidget(moduleCode, this.props.activeUser.id);
    }

    fillWidgets() {
        let displayInterventionsWidget = !this.props.hiddenHomeWidgets.find(w => w.moduleCode === MODULE_EXTRANET_INTERVENTIONS)
        let displayContractAndAffairsWidget = !this.props.hiddenHomeWidgets.find(w => w.moduleCode === MODULE_EXTRANET_CONTRACTS_AND_AFFAIRS)
        let displayInvoicesWidget = !this.props.hiddenHomeWidgets.find(w => w.moduleCode === MODULE_EXTRANET_INVOICES)
        let displayComponentsParkWidget = !this.props.hiddenHomeWidgets.find(w => w.moduleCode === MODULE_EXTRANET_COMPONENTS_PARK)
        let displayQuotesWidget = !this.props.hiddenHomeWidgets.find(w => w.moduleCode === MODULE_EXTRANET_QUOTES)
        let displayContactUsWidget = !this.props.hiddenHomeWidgets.find(w => w.moduleCode === MODULE_CONTACT_US)
        // let displayIndicatorsWidget = !this.props.hiddenHomeWidgets.find(w => w.moduleCode === MODULE_EXTRANET_INDICATORS)
        // let displayDocumentationWidget = !this.props.hiddenHomeWidgets.find(w => w.moduleCode === MODULE_EXTRANET_DOCUMENTATIONS)

        let widgetsElements = [];
        let keyIndex = 0;

        if (displayInterventionsWidget)
            widgetsElements.push(<PlannedInterventions key={"w" + keyIndex++} globalContainer={this.props.globalStore.container} classes={this.props.classes}
                className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 home-card" close={this.closeCard.bind(this, MODULE_EXTRANET_INTERVENTIONS)} />)

        if (displayContractAndAffairsWidget)
            widgetsElements.push(<ContractsAndAffairs key={"w" + keyIndex++} globalContainer={this.props.globalStore.container} classes={this.props.classes}
                className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 home-card" close={this.closeCard.bind(this, MODULE_EXTRANET_CONTRACTS_AND_AFFAIRS)} />)

        if (displayInvoicesWidget)
            widgetsElements.push(<MyInvoices key={"w" + keyIndex++} globalContainer={this.props.globalStore.container} classes={this.props.classes}
                className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 home-card" close={this.closeCard.bind(this, MODULE_EXTRANET_INVOICES)} />)


        let pairOfSmallWidgetsElement = [];
        let smallWidgets = []

        if (displayComponentsParkWidget)
            smallWidgets.push(
                <MyComponentPark key={"sw" + keyIndex++} classes={this.props.classes} close={this.closeCard.bind(this, MODULE_EXTRANET_COMPONENTS_PARK)}
                    className={("col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 small-home-card without-padding") + (pairOfSmallWidgetsElement.length === 0 ? " small-home-card-margin-bottom" : "")} />
            )

        if (displayQuotesWidget)
            smallWidgets.push(
                <Quotes classes={this.props.classes} key={"sw" + keyIndex++} close={this.closeCard.bind(this, MODULE_EXTRANET_QUOTES)}
                    className={("col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 small-home-card without-padding") + (pairOfSmallWidgetsElement.length === 0 ? " small-home-card-margin-bottom" : "")} />
            )

        if (displayContactUsWidget)
            smallWidgets.push(
                <ContactUs classes={this.props.classes} key={"sw" + keyIndex++} close={this.closeCard.bind(this, MODULE_CONTACT_US)}
                    className={("col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 small-home-card small-home-card-margin-bottom without-padding") + (pairOfSmallWidgetsElement.length === 0 ? " small-home-card-margin-bottom" : "")} />
            )

        // if (displayIndicatorsWidget)
        //     smallWidgets.push(
        //         <Indicators classes={this.props.classes} key={"sw" + keyIndex++} close={this.closeCard.bind(this, MODULE_EXTRANET_INDICATORS)}
        //             className={("col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 small-home-card small-home-card-margin-bottom without-padding") + (pairOfSmallWidgetsElement.length === 0 ? " small-home-card-margin-bottom" : "")} />
        //     )

        // if (displayDocumentationWidget)
        //     smallWidgets.push(
        //         <Documentations classes={this.props.classes} key={"sw" + keyIndex++} close={this.closeCard.bind(this, MODULE_EXTRANET_DOCUMENTATIONS)}
        //             className={("col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 small-home-card without-padding") + (pairOfSmallWidgetsElement.length === 0 ? " small-home-card-margin-bottom" : "")} />
        //     )

        if (smallWidgets.length % 2 > 0)
            smallWidgets.push(<div classes={this.props.classes} key={"sw" + keyIndex++} className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 small-home-card without-padding" />)

        widgetsElements = this.fillSmallWidgetElements(smallWidgets, widgetsElements)

        return widgetsElements;
    }

    fillSmallWidgetElements(smallWidgets, widgetsElements) {
        let pairOfSmallWidgetsElement = []


        smallWidgets.forEach((w, index) => {

            pairOfSmallWidgetsElement.push(w)

            if (pairOfSmallWidgetsElement.length === 2) {
                widgetsElements.push(
                    (<div key={"psw" + index} className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 home-card row" >
                        {pairOfSmallWidgetsElement.map(w => w)}
                    </div>)
                )

                pairOfSmallWidgetsElement = [];
            }
        })


        return widgetsElements
    }

    render() {
        if(!getUserToken())
            return null;

        let widgetsElements = this.fillWidgets();

        return (
            <div>
                <div className="col-lg-12 col-md-12 col-sm-12 col-12 row without-padding">
                    {widgetsElements.map(w => w)}
                </div>
            </div >
        );
    }
}

const mapStateToProps = (state) => {
    return {
        activeUser: state.activeUser,
        hiddenHomeWidgets: state.homeWidgets.hiddenHomeWidgets,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchData: (user) => dispatch(authorizedAppsFetchData(user)),
        hideWidget: (moduleCode, userId) => dispatch(hideWidget(moduleCode, userId)),
        loadHiddenWidgets: (userId) => dispatch(loadHiddenWidgets(userId)),
    };
};

export default compose(withStyles(styles), withAuth, connect(mapStateToProps, mapDispatchToProps))(ExtranetHome);
